import { useEffect, useState } from 'react';
import { DEAL_MS } from './stage';

/** How many board cards have landed: the cards first seen in a render (`fresh` delays) land `delay + DEAL_MS` later, one step each. */
export function useLandedBoard(handId: string | null, boardLen: number, fresh: number[]): number {
  const [landed, setLanded] = useState(boardLen - fresh.length);
  useEffect(() => {
    const base = boardLen - fresh.length;
    setLanded(base);
    const timers = fresh.map((d, k) => window.setTimeout(() => setLanded(base + k + 1), d + DEAL_MS));
    return () => timers.forEach(t => window.clearTimeout(t));
    // `fresh` belongs to the render in which the board grew
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handId, boardLen]);
  return landed;
}
